import { Box, Flex, FlexProps } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useShowCache } from 'src/apollo/cache';
import { Host } from 'src/generated/graphql';
import Icons from 'src/components/menu/Icons';
import { useMenuContext } from '../MenuContext';
import NavButton from './components/NavButton';
import NavButtonsContainer from './components/NavButtonsContainer';

const buttonContainerProps = {
  position: 'absolute',
  left: 'calc((72px - 48px) / 2)',
} as Partial<FlexProps>;

export function MenuHeader() {
  const [menuState] = useMenuContext();
  const show = useShowCache();

  return menuState === 'closed' ? (
    <Box>
      <AlituLogoWithoutText />
      <NavButtonsContainer {...buttonContainerProps}>
        <NavButton page="episodes" px="11px" />
        <NavButton page="call-recorder" px="10px" />
        <NavButton page="clip-genie" px="11px" />
        <NavButton page="library" px="13px" />
        {show?.host === Host.Alitu && <NavButton page="statistics" px="10px" />}
      </NavButtonsContainer>
    </Box>
  ) : (
    <Box>
      <AlituLogoWithText />
      <NavButtonsContainer>
        <NavButton page="episodes" />
        <NavButton page="call-recorder" />
        <NavButton page="clip-genie" />
        <NavButton page="library" />
        {show?.host === Host.Alitu && <NavButton page="statistics" />}
      </NavButtonsContainer>
    </Box>
  );
}

function AlituLogoWithText() {
  const navigate = useNavigate();

  return (
    <Box mb="30px" pl="16px">
      <button type="button" onClick={() => navigate('/episodes')}>
        <Icons.AlituLogoWithText />
      </button>
    </Box>
  );
}

function AlituLogoWithoutText() {
  const navigate = useNavigate();

  return (
    <Flex mb="18px" justifyContent="center">
      <button type="button" onClick={() => navigate('/episodes')}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.694 35.9869C18.4638 35.9956 18.2324 36 18 36C17.7676 36 17.5362 35.9956 17.306 35.9869H18.694ZM29.1972 32.0942C33.3425 28.7966 36 23.7086 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 23.7068 2.65576 28.7933 6.79883 32.0911V25.048C6.85585 22.1155 8.06081 19.3224 10.1549 17.2686C11.9866 15.4721 14.3709 14.3668 16.9027 14.1181C16.7144 13.3631 16.4797 12.3818 16.2814 11.3239C15.4782 11.0441 14.6983 10.7016 13.9488 10.2994L13.7583 10.2021L14.6558 8.50876L14.842 8.60613C15.2273 8.80933 15.5998 8.99136 15.9596 9.14799C15.8989 8.51459 15.9963 7.87603 16.2432 7.28958C16.7682 6.12965 18.017 5.39305 19.5833 5.32532C21.2936 5.24489 22.8303 5.98148 23.4991 7.16681C24.295 8.58073 23.7108 10.3756 22.1614 11.2519C21.1625 11.7749 20.0319 11.9927 18.9102 11.8785C18.7197 11.8658 18.5292 11.8446 18.3387 11.8192C18.5123 12.6362 18.7028 13.4109 18.8721 14.0671L18.8803 14.0992C21.4912 14.3054 23.9581 15.4218 25.8412 17.2686C27.9352 19.3224 29.1402 22.1155 29.1972 25.048V32.0942ZM21.2132 9.58826C20.5432 9.91903 19.7926 10.0512 19.0499 9.96925C18.6881 9.94139 18.3288 9.88763 17.9747 9.80838C17.945 9.62212 17.9196 9.43586 17.8985 9.24536C17.8219 8.85441 17.8556 8.44985 17.9958 8.07697C18.2541 7.50547 19.0288 7.27264 19.668 7.23031C20.6163 7.18797 21.5222 7.55203 21.827 8.09813C22.1318 8.64422 21.8312 9.22843 21.2132 9.58826ZM13.6696 25.4505C13.6696 26.4512 12.8584 27.2624 11.8578 27.2624C10.8571 27.2624 10.0459 26.4512 10.0459 25.4505C10.0459 24.4499 10.8571 23.6387 11.8578 23.6387C12.8584 23.6387 13.6696 24.4499 13.6696 25.4505ZM26.0094 25.4505C26.0094 26.4512 25.1983 27.2624 24.1976 27.2624C23.1969 27.2624 22.3857 26.4512 22.3857 25.4505C22.3857 24.4499 23.1969 23.6387 24.1976 23.6387C25.1983 23.6387 26.0094 24.4499 26.0094 25.4505ZM19.0503 29.3623H17.0049V33.1437C17.1591 33.1627 17.3146 33.1723 17.4706 33.1723H18.5755C18.7346 33.1723 18.8931 33.1623 19.0503 33.1426V29.3623ZM20.1256 32.8427V29.3623H22.3855C22.3855 29.8626 22.2869 30.3581 22.0955 30.8203C21.904 31.2826 21.6234 31.7026 21.2696 32.0564C20.9394 32.3865 20.5516 32.653 20.1256 32.8427ZM13.6649 29.3623H15.9297V32.8468C15.5001 32.6568 15.1091 32.3889 14.7766 32.0564C14.4228 31.7026 14.1421 31.2826 13.9507 30.8203C13.7592 30.3581 13.6606 29.8626 13.6606 29.3623H13.6649Z"
            fill="white"
          />
        </svg>
      </button>
    </Flex>
  );
}
